module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "3",
      "md": "3"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadAll()
      }
    }
  }, [_vm._v("\n          Reload All\n          "), _c('i', {
    staticClass: "fa fa-repeat"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openReportPasscodeDialog.apply(null, arguments)
      }
    }
  }, [_vm._v("Export")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedLists.length > 0),
      expression: "selectedLists.length > 0"
    }],
    attrs: {
      "small": "",
      "color": "warning",
      "disabled": !_vm.selectedLists || _vm.selectedLists.length === 0
    },
    on: {
      "click": function($event) {
        return _vm.openAddPairingCampaignModal()
      }
    }
  }, [_vm._v("Add to Pairing (" + _vm._s(_vm.selectedLists.length) + ")")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "9",
      "md": "9"
    }
  }, [_c('v-row', {
    staticStyle: {
      "width": "100%",
      "justify-content": "right"
    },
    attrs: {
      "justify": "right",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pr-0",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.platformList,
      "item-value": "value",
      "item-text": "text"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.selectedPlatform),
      callback: function($$v) {
        _vm.selectedPlatform = $$v
      },
      expression: "selectedPlatform"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "5",
      "lg": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "label": "Search Handle",
      "hide-details": "auto",
      "id": "igHandle"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.igHandle),
      callback: function($$v) {
        _vm.igHandle = $$v
      },
      expression: "igHandle"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin": "30px 0px 0px 0px"
    },
    attrs: {
      "justify": "right",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.countries,
      "dense": "",
      "hide-selected": "",
      "clearable": "",
      "small-chips": "",
      "outlined": "",
      "hide-details": "auto",
      "label": "Country"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.influencerGeos),
      callback: function($$v) {
        _vm.influencerGeos = $$v
      },
      expression: "influencerGeos"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Gender",
      "items": _vm.searchConfig.genderOptions,
      "item-value": "value",
      "item-text": "text"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.searchFilter.gender),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "gender", $$v)
      },
      expression: "searchFilter.gender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "IMS Status",
      "items": _vm.searchConfig.imsOptions,
      "item-value": "value",
      "item-text": "text"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.searchFilter.isIMS),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "isIMS", $$v)
      },
      expression: "searchFilter.isIMS"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "label": "Campaigns",
      "items": _vm.filterCampaigns,
      "item-value": "id",
      "item-text": "name"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.searchFilter.campaign),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "campaign", $$v)
      },
      expression: "searchFilter.campaign"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "label": "Aud. Credibilty",
      "items": _vm.audCredibilities
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-chip', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "x-small": "",
            "color": item,
            "text-color": "white"
          }
        })]
      }
    }, {
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-chip', {
          staticStyle: {
            "width": "100%",
            "margin-top": "10px",
            "margin-bottom": "-26px"
          },
          attrs: {
            "x-small": "",
            "color": item,
            "text-color": "white"
          }
        })]
      }
    }]),
    model: {
      value: (_vm.searchFilter.credibility),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "credibility", $$v)
      },
      expression: "searchFilter.credibility"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.audienceInterestLists,
      "item-text": "name",
      "item-value": "name",
      "hide-selected": "",
      "multiple": "",
      "clearable": "",
      "small-chips": "",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "label": "Influencer Interests"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          attrs: {
            "input-value": data.selected,
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.removeInfInterest(data.item)
            }
          }
        }, [_c('strong', [_vm._v(_vm._s(data.item.name))]), _vm._v(" \n            ")])]
      }
    }]),
    model: {
      value: (_vm.searchFilter.infInterest),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "infInterest", $$v)
      },
      expression: "searchFilter.infInterest"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ml-0",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticStyle: {
      "min-width": "175px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "1",
      "lg": "1"
    }
  }, [_c('v-menu', {
    staticStyle: {
      "min-height": "250px"
    },
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n              Aud. Country "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('p', {
    staticClass: "subtitle-2 mb-0"
  }, [_vm._v("Select Countries")])]), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    staticClass: "pt-2",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.countries,
      "dense": "",
      "hide-selected": "",
      "multiple": "",
      "clearable": "",
      "small-chips": "",
      "outlined": "",
      "hide-details": "auto",
      "label": "Aud. Country"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          attrs: {
            "small": "",
            "input-value": data.selected,
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.removeAudGeos(data.item)
            }
          }
        }, [_c('strong', [_vm._v(_vm._s(data.item))]), _vm._v(" \n                      ")])]
      }
    }]),
    model: {
      value: (_vm.audGeos),
      callback: function($$v) {
        _vm.audGeos = $$v
      },
      expression: "audGeos"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    staticClass: "pt-5",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.creatorAgePercentOptions
    },
    model: {
      value: (_vm.audGeoPercent),
      callback: function($$v) {
        _vm.audGeoPercent = $$v
      },
      expression: "audGeoPercent"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pt-5"
  }, [_c('v-list-item', {
    staticStyle: {
      "min-height": "0"
    }
  }, [_c('p', {
    staticClass: "subtitle-2 mb-0"
  }, [_vm._v("Size")])]), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "min-height": "150px"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.limitOptions
    },
    model: {
      value: (_vm.searchFilter.limit),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "limit", $$v)
      },
      expression: "searchFilter.limit"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-28px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.paginate()
      }
    }
  }, [_vm._v("\n                Apply\n              ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "1",
      "lg": "1"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n              Followers "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                  From\n                  "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.followerOptions.from
    },
    model: {
      value: (_vm.searchFilter.followers.from),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter.followers, "from", $$v)
      },
      expression: "searchFilter.followers.from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                  To\n                  "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.followerOptions.to
    },
    model: {
      value: (_vm.searchFilter.followers.to),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter.followers, "to", $$v)
      },
      expression: "searchFilter.followers.to"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-28px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.paginate()
      }
    }
  }, [_vm._v("\n                Apply\n              ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "1",
      "lg": "1"
    }
  }, [_c('v-menu', {
    staticStyle: {
      "min-height": "250px"
    },
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n              Age Group "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('p', {
    staticClass: "subtitle-2 mb-0"
  }, [_vm._v("Audience")])]), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    staticClass: "pt-2",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.creatorAgeOptions
    },
    model: {
      value: (_vm.searchFilter.ageGroup),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "ageGroup", $$v)
      },
      expression: "searchFilter.ageGroup"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    staticClass: "pt-5",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.creatorAgePercentOptions
    },
    model: {
      value: (_vm.searchFilter.ageGroupPercent),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "ageGroupPercent", $$v)
      },
      expression: "searchFilter.ageGroupPercent"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('p', {
    staticClass: "subtitle-2 mb-0"
  }, [_vm._v("2nd Deg. Audience")])]), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    staticClass: "pt-2",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.creatorAgeOptions
    },
    model: {
      value: (_vm.searchFilter.secAgeGroup),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "secAgeGroup", $$v)
      },
      expression: "searchFilter.secAgeGroup"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    staticClass: "pt-5",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.creatorAgePercentOptions
    },
    model: {
      value: (_vm.searchFilter.secAgeGroupPercent),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "secAgeGroupPercent", $$v)
      },
      expression: "searchFilter.secAgeGroupPercent"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pt-5"
  }, [_c('v-list-item', {
    staticStyle: {
      "min-height": "0"
    }
  }, [_c('p', {
    staticClass: "subtitle-2 mb-0"
  }, [_vm._v("Size")])]), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "min-height": "150px"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.limitOptions
    },
    model: {
      value: (_vm.searchFilter.limit),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "limit", $$v)
      },
      expression: "searchFilter.limit"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-28px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.paginate()
      }
    }
  }, [_vm._v("\n                Apply\n              ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "min-width": "180px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "1",
      "lg": "1"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n              Aud. Interests "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "150px"
    }
  }, [_c('v-list-item', [_c('v-list-item-title', [_c('p', {
    staticClass: "subtitle-2 mb-0"
  }, [_vm._v("Select")])])], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.audienceInterestLists,
      "item-text": "name",
      "item-value": "name",
      "hide-selected": "",
      "multiple": "",
      "clearable": "",
      "small-chips": "",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "label": "Audience Interests"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          attrs: {
            "input-value": data.selected,
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.removeAudInterest(data.item)
            }
          }
        }, [_c('strong', [_vm._v(_vm._s(data.item.name))]), _vm._v(" \n                      ")])]
      }
    }]),
    model: {
      value: (_vm.searchFilter.audienceInterest),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "audienceInterest", $$v)
      },
      expression: "searchFilter.audienceInterest"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    staticClass: "pt-5",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.creatorAgePercentOptions
    },
    model: {
      value: (_vm.audInterestPercent),
      callback: function($$v) {
        _vm.audInterestPercent = $$v
      },
      expression: "audInterestPercent"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pt-5"
  }, [_c('v-list-item', {
    staticStyle: {
      "min-height": "0"
    }
  }, [_c('p', {
    staticClass: "subtitle-2 mb-0"
  }, [_vm._v("Size")])]), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "min-height": "150px"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.limitOptions
    },
    model: {
      value: (_vm.searchFilter.limit),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "limit", $$v)
      },
      expression: "searchFilter.limit"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-28px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.paginate()
      }
    }
  }, [_vm._v("\n                Apply\n              ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "min-width": "175px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "1",
      "lg": "1"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n              Engagements "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "150px"
    }
  }, [_c('v-list-item', [_c('v-list-item-title', [_vm._v("Engagement Rate")])], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                  To (%)\n                  "), _c('v-autocomplete', {
    staticClass: "mt-2",
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.engRatePercentageOptions.to
    },
    model: {
      value: (_vm.searchFilter.engagementRate.to),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter.engagementRate, "to", $$v)
      },
      expression: "searchFilter.engagementRate.to"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-28px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.paginate()
      }
    }
  }, [_vm._v("\n                Apply\n              ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "250px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n              Paid Post Performance "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                  From (%)\n                  "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.paidPstPerformanceOptions.from
    },
    model: {
      value: (_vm.searchFilter.paidPstPerformance.from),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter.paidPstPerformance, "from", $$v)
      },
      expression: "searchFilter.paidPstPerformance.from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                  To (%)\n                  "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.paidPstPerformanceOptions.to
    },
    model: {
      value: (_vm.searchFilter.paidPstPerformance.to),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter.paidPstPerformance, "to", $$v)
      },
      expression: "searchFilter.paidPstPerformance.to"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-28px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.paginate()
      }
    }
  }, [_vm._v("\n                Apply\n              ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.showFilters) ? _c('v-row', {
    staticClass: "ml-3 mt-5",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row flex-wrap"
  }, [_c('p', {
    staticClass: "body-2 mr-2 pt-2"
  }, [_vm._v("Filters:")]), _vm._v(" "), _vm._l((_vm.getFilterLists), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-chip', {
            staticClass: "mr-2",
            attrs: {
              "color": "default"
            }
          }, [_c('v-icon', _vm._g({
            attrs: {
              "left": ""
            }
          }, on), [_vm._v(_vm._s(item.icon))]), _vm._v(" "), (item.value) ? _c('span', [_vm._v(_vm._s(item.value))]) : _vm._e(), _vm._v(" "), (item.htmlValue) ? _c('span', {
            domProps: {
              "innerHTML": _vm._s(item.htmlValue)
            }
          }) : _vm._e(), _vm._v(" "), _c('v-btn', {
            staticClass: "btn-close",
            attrs: {
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.removeFilterShow(item.type)
              }
            }
          }, [_c('v-icon', _vm._g({
            attrs: {
              "left": ""
            }
          }, on), [_vm._v("mdi-close")])], 1)], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])])], 1)
  })], 2)]) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "pt-0 pb-0"
  }, [_c('v-col', {
    staticClass: "pt-0 pb-0",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right!important"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1)])], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "viewCompany",
      "data-toggle": "modal",
      "data-target": _vm.viewCompanyModalIdDisplay
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "viewPosts",
      "data-toggle": "modal",
      "data-target": _vm.influencerPostDisplay
    }
  }), _vm._v(" "), _c('v-data-table', {
    staticClass: "table-small elevation-1",
    attrs: {
      "headers": _vm.computedHeaders,
      "items": _vm.items,
      "loading": _vm.loading,
      "options": _vm.pagination,
      "footer-props": {
        itemsPerPageOptions: _vm.rowsPerPageItems
      },
      "server-items-length": _vm.totalItems,
      "item-key": "id",
      "show-select": "",
      "single-select": false
    },
    on: {
      "update:options": function($event) {
        _vm.pagination = $event
      },
      "toggle-select-all": _vm.selectAllLists
    },
    scopedSlots: _vm._u([{
      key: "item.data-table-select",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "d-flex flex-row",
          staticStyle: {
            "margin-left": "18px"
          }
        }, [_c('v-checkbox', {
          staticStyle: {
            "margin-right": "-12px"
          },
          attrs: {
            "label": "",
            "value": item,
            "color": "grey darken-2"
          },
          model: {
            value: (_vm.selectedLists),
            callback: function($$v) {
              _vm.selectedLists = $$v
            },
            expression: "selectedLists"
          }
        }), _vm._v(" "), _c('v-btn', {
          staticClass: "btn-reload",
          staticStyle: {
            "margin-top": "22px"
          },
          attrs: {
            "text": "",
            "x-small": "",
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.refreshReport(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": "",
            "small": ""
          }
        }, [_vm._v("\n                      mdi-reload\n                    ")])], 1)], 1)]
      }
    }, {
      key: "item.profilePicture",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', [_c('v-avatar', {
          attrs: {
            "size": _vm.avatarSize,
            "color": "grey lighten-4"
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.paserImageUrl(item.profilePicture),
            "alt": "avatar"
          }
        })])], 1)])]
      }
    }, {
      key: "item.instagramHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(_vm.selectedPlatform === 'tiktok') ? _c('a', {
          attrs: {
            "target": "_blank",
            "href": 'https://www.tiktok.com/@' + item.instagramHandle
          }
        }, [_vm._v("@" + _vm._s(item.instagramHandle))]) : (_vm.selectedPlatform === 'youtube') ? _c('a', {
          attrs: {
            "target": "_blank",
            "href": item.url
          }
        }, [_vm._v("@" + _vm._s(item.instagramHandle || item.fullName))]) : _c('a', {
          attrs: {
            "target": "_blank",
            "href": 'https://instagram.com/' + item.instagramHandle
          }
        }, [_vm._v("@" + _vm._s(item.instagramHandle))]), _vm._v(" "), (item.importedCreator) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": "secondary",
                  "small": ""
                },
                on: {
                  "click": true
                }
              }, on), [_vm._v("mdi-newspaper-plus")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Imported Creator")])]) : _vm._e()], 1)])]
      }
    }, {
      key: "item.campaigns",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, _vm._l((item.campaignTypes), function(campaignType, index) {
          return _c('div', {
            key: index
          }, [(campaignType.count > 0) ? _c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.openCampaignListsModal(item, item.instagramHandle)
              }
            }
          }, [_c('subtitle-1', [_vm._v(_vm._s(campaignType.name))]), _vm._v("  "), _c('b', [_vm._v("(" + _vm._s(campaignType.count) + ")")])], 1) : _vm._e()], 1)
        }), 0)])]
      }
    }, {
      key: "item.totalFollowers",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.totalFollowers)) + "\n                  ")])])]
      }
    }, {
      key: "item.country",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.countries || item.countries.length === 0) ? _c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "text-transform": "capitalize"
          },
          attrs: {
            "color": "#ffffff",
            "x-small": "",
            "text-color": "black"
          }
        }, [_vm._v(_vm._s('-'))]) : _vm._l((item.countries), function(country, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index === 0),
              expression: "index === 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(_vm._s(country.name))])
        }), _vm._v(" "), _c('v-menu', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.countries),
            expression: "item.countries"
          }],
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (item.countries && item.countries.length > 0),
                  expression: "item.countries && item.countries.length > 0"
                }],
                attrs: {
                  "id": 'btnMore_' + _vm.parentIndex,
                  "color": "secondary",
                  "x-small": "",
                  "dark": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                      More...\n                    ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('v-card-text', [_c('div', [_vm._v("Countries")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.countries), function(country, index) {
          return _c('div', {
            key: index,
            staticClass: "d-flex justify-space-between"
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(_vm._s(country.name))]), _vm._v(" "), _c('span', {
            staticClass: "more-percent"
          }, [_vm._v("(" + _vm._s((country.weight * 100).toFixed(2)) + "%)")])], 1)
        })], 2)], 1)], 1)]
      }
    }, {
      key: "item.genderPercentage",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticStyle: {
            "width": "75px"
          }
        }, [(item.audienceGenders.length > 0) ? _c('PieChart', {
          attrs: {
            "name": ("genderPie" + (item.id)),
            "title": _vm.genderPie.title,
            "labels": _vm.genderPie.labels,
            "backgroundColors": _vm.genderPie.backgroundColors,
            "items": _vm.getGenderPieData(item.audienceGenders),
            "options": _vm.genderPie.options,
            "width": _vm.genderPie.width,
            "height": _vm.genderPie.height
          }
        }) : _vm._e()], 1)])])]
      }
    }, {
      key: "item.ageGroup",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "pa-2",
          staticStyle: {
            "max-width": "84px!important",
            "max-height": "84px!important"
          }
        }, [_c('bar-chart', {
          attrs: {
            "options": _vm.barChartOptions,
            "chart-data": item.ageGroupDisplay
          }
        }), _vm._v(" "), _c('v-menu', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.audienceAges),
            expression: "item.audienceAges"
          }],
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (item.audienceAges && item.audienceAges.length > 0),
                  expression: "item.audienceAges && item.audienceAges.length > 0"
                }],
                staticStyle: {
                  "margin-top": "-25px"
                },
                attrs: {
                  "id": 'btnMore_' + _vm.parentIndex,
                  "color": "secondary",
                  "x-small": "",
                  "dark": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                            More...\n                          ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('v-card-text', [_c('div', [_vm._v("Aud. Age Groups")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.getSortedAges(item.audienceAges)), function(age, index) {
          return _c('div', {
            key: index,
            staticClass: "d-flex justify-space-between"
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(_vm._s(age.code))]), _vm._v(" "), _c('span', {
            staticClass: "more-percent"
          }, [_vm._v("(" + _vm._s((age.weight * 100).toFixed(2)) + "%)")])], 1)
        })], 2)], 1)], 1)], 1)])])]
      }
    }, {
      key: "item.creatorAgeGroup",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                    " + _vm._s(item.ageGroup) + "\n                  ")])])]
      }
    }, {
      key: "item.engagements",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("abbr")(parseInt(item.engagements))) + "\n                  ")])])]
      }
    }, {
      key: "item.engagementRate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                    " + _vm._s(item.engagementRate) + "%\n                  ")])])]
      }
    }, {
      key: "item.paidPstPerformance",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                    " + _vm._s(item.paidPstPerformance)), (item.paidPstPerformance !== '-') ? _c('span', [_vm._v("%")]) : _vm._e()])])]
      }
    }, {
      key: "item.audienceCredibility",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [(_vm.selectedPlatform === 'instagram') ? _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "width": "50px"
          },
          attrs: {
            "x-small": "",
            "color": item.audienceCredibilityColor,
            "text-color": "white"
          }
        })], 1) : _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                    " + _vm._s(item.audienceCredibility) + "\n                  ")])])]
      }
    }, {
      key: "item.rateCard",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-menu', {
          attrs: {
            "max-height": "500px",
            "close-on-content-click": false,
            "top": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "color": "secondary",
                  "x-small": "",
                  "text": ""
                },
                on: {
                  "click": function($event) {
                    return _vm.getRateCard(item)
                  }
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                      View\n                    ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left",
            "width": "300px"
          },
          attrs: {
            "max-width": "350"
          }
        }, [_c('v-card-text', [_c('v-expansion-panels', {
          attrs: {
            "multiple": ""
          },
          model: {
            value: (_vm.openExpansion),
            callback: function($$v) {
              _vm.openExpansion = $$v
            },
            expression: "openExpansion"
          }
        }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('div', [_vm._v("IMS Imported Rates "), _c('br'), _c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("(in SGD per item)")])])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('rate-card-preview', {
          attrs: {
            "data": _vm.inputRates,
            "type": "IMS"
          }
        })], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('div', [_vm._v("Rate Card Form Rates "), _c('br'), _c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("(in SGD per item)")])])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('rate-card-preview', {
          attrs: {
            "data": _vm.rateCardFormRates,
            "type": "rateCard"
          }
        })], 1)], 1)], 1)], 1)], 1)], 1)]
      }
    }, {
      key: "item.infInterests",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.infInterests || item.infInterests.length === 0) ? _c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "text-transform": "capitalize"
          },
          attrs: {
            "color": "#ffffff",
            "x-small": "",
            "text-color": "black"
          }
        }, [_vm._v(_vm._s('-'))]) : _vm._l((item.infInterests), function(interest, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index === 0),
              expression: "index === 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(_vm._s(interest.name))])
        }), _vm._v(" "), _c('v-menu', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.infInterests),
            expression: "item.infInterests"
          }],
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (item.infInterests && item.infInterests.length > 0),
                  expression: "item.infInterests && item.infInterests.length > 0"
                }],
                attrs: {
                  "id": 'btnMore_' + item.id,
                  "color": "secondary",
                  "x-small": "",
                  "dark": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                      More...\n                    ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('v-card-text', [_c('div', [_vm._v("Influencer Interests")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.infInterests), function(interest, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index !== 0),
              expression: "index !== 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "small": ""
            }
          }, [_vm._v(_vm._s(interest.name))])
        })], 2)], 1)], 1)]
      }
    }, {
      key: "item.audienceInterests",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.audienceInterests || item.audienceInterests.length === 0) ? _c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "text-transform": "capitalize"
          },
          attrs: {
            "color": "#ffffff",
            "x-small": "",
            "text-color": "black"
          }
        }, [_vm._v(_vm._s('-'))]) : _vm._l((item.audienceInterests), function(interest, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index === 0),
              expression: "index === 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(_vm._s(interest.name))])
        }), _vm._v(" "), _c('v-menu', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.audienceInterests),
            expression: "item.audienceInterests"
          }],
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (item.audienceInterests && item.audienceInterests.length > 0),
                  expression: "item.audienceInterests && item.audienceInterests.length > 0"
                }],
                attrs: {
                  "id": 'btnMore_' + _vm.parentIndex,
                  "color": "secondary",
                  "x-small": "",
                  "dark": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                      More...\n                    ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('v-card-text', [_c('div', [_vm._v("Audience Interests")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.audienceInterests), function(interest, index) {
          return _c('div', {
            key: index,
            staticClass: "d-flex justify-space-between"
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(_vm._s(interest.name))]), _vm._v(" "), _c('span', {
            staticStyle: {}
          }, [_vm._v("(" + _vm._s((interest.weight * 100).toFixed(2)) + "%)")])], 1)
        })], 2)], 1)], 1)]
      }
    }, {
      key: "item.avgViews",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avgViews)) + "\n                  ")])])]
      }
    }, {
      key: "item.avgLikes",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avgLikes)) + "\n                  ")])])]
      }
    }, {
      key: "item.avgComments",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avgComments)) + "\n                  ")])])]
      }
    }, {
      key: "item.avgReelPlays",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avgReelPlays)) + "\n                  ")])])]
      }
    }, {
      key: "item.medianEngagements",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "115px"
          }
        }, [_c('div', {
          staticClass: "clearfix"
        }, [_c('ul', {
          attrs: {
            "id": "progressbar"
          }
        }, _vm._l((item.medianEngagements), function(eng, index) {
          return _c('li', {
            key: index,
            class: {
              'active red-color': !eng.median && index <= item.influencerIndex && item.influencerIndex < item.medianIndex,
              'active green-color': !eng.median && index <= item.influencerIndex && item.influencerIndex >= item.medianIndex,
              'median': eng.median && item.influencerIndex < item.medianIndex,
              'median green-color': eng.median && item.influencerIndex >= item.medianIndex
            }
          }, [(eng.median) ? _c('span', [_vm._v("Median")]) : _vm._e()])
        }), 0)]), _vm._v(" "), _c('div', [_c('v-btn', {
          attrs: {
            "x-small": "",
            "text": "",
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.openMedianEngModal(item)
            }
          }
        }, [_vm._v("\n                        Details\n                      ")])], 1)])])]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(props.item.totalFollowers)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.engagementRate) + "%")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.audienceCredibility) + "%")])])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "justify-center layout px-0"
        }, [_c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.showReport(item)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("assessment")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View Audience Data")])])], 1), _vm._v(" "), (!item.isIMS && _vm.isSuperAdminRole) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.deleteAud(item)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "small": ""
                }
              }, on), [_vm._v("mdi-trash-can-outline")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Delete")])])], 1) : _vm._e()], 1)])]
      }
    }], null, true),
    model: {
      value: (_vm.selectedLists),
      callback: function($$v) {
        _vm.selectedLists = $$v
      },
      expression: "selectedLists"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('audience-data-report-modal', {
    attrs: {
      "audienceData": _vm.audienceDataReport
    },
    on: {
      "showLoadingEvent": _vm.showLoadingEvent
    },
    model: {
      value: (_vm.viewAudienceDataDialog),
      callback: function($$v) {
        _vm.viewAudienceDataDialog = $$v
      },
      expression: "viewAudienceDataDialog"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.showLoading),
      callback: function($$v) {
        _vm.showLoading = $$v
      },
      expression: "showLoading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v("\n        Exporting your data.\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v("\n        Please stand by\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('input', {
    ref: "igBulkHandle",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xlsx",
      "id": "igBulkHandle"
    },
    on: {
      "change": _vm.igHandleBulkUpload
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.importLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.importLoading = $event
      }
    }
  }), _vm._v(" "), _c('campaign-lists-modal', {
    attrs: {
      "items": _vm.viewCampaigns,
      "handle": _vm.viewHandle,
      "value": _vm.viewCampaignListsDialog
    },
    model: {
      value: (_vm.viewCampaignListsDialog),
      callback: function($$v) {
        _vm.viewCampaignListsDialog = $$v
      },
      expression: "viewCampaignListsDialog"
    }
  }), _vm._v(" "), _c('median-engagements-modal', {
    attrs: {
      "items": _vm.viewMedianEngs,
      "handle": _vm.viewHandle,
      "engagementRate": _vm.viewEngRate,
      "followersRange": _vm.viewFollowersRange,
      "value": _vm.viewMedianEngDialog
    },
    model: {
      value: (_vm.viewMedianEngDialog),
      callback: function($$v) {
        _vm.viewMedianEngDialog = $$v
      },
      expression: "viewMedianEngDialog"
    }
  }), _vm._v(" "), _c('add-influencer-pairing-modal', {
    attrs: {
      "selectedInfluencers": _vm.selectedLists,
      "value": _vm.addInfluencerPairingDialog
    },
    model: {
      value: (_vm.addInfluencerPairingDialog),
      callback: function($$v) {
        _vm.addInfluencerPairingDialog = $$v
      },
      expression: "addInfluencerPairingDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "All Influencers",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  }), _vm._v(" "), _c('all-reports-passcode-modal', {
    attrs: {
      "value": _vm.allReportsPasscodeDialog,
      "reportType": _vm.downloadReportType
    },
    on: {
      "success": _vm.reportPasscodeSuccess
    },
    model: {
      value: (_vm.allReportsPasscodeDialog),
      callback: function($$v) {
        _vm.allReportsPasscodeDialog = $$v
      },
      expression: "allReportsPasscodeDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1368a38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/NonIMSLists.vue
// module id = 2269
// module chunks = 0